// extracted by mini-css-extract-plugin
module.exports = {"header":"ReprocessingJobs-module__header___1pFws","card":"ReprocessingJobs-module__card___3mcwk"};